/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, string, arrayOf, shape, number, func,
} from 'prop-types';
import {
    Grid, Typography, useMediaQuery, withStyles,
} from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { useDispatch } from 'react-redux';
import Address from '../DesktopGiftList/RecipientDetails/Address';
import RecipientBoxExpand from './RecipientBoxExpand';
import ProductAddedToCart from './ProductAddedToCart';
import { isEmpty } from '../../../utils/object';
import GiftListAddedProduct from './GiftListAddedProduct';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    collapseContainer: {
        padding: '24px 0px 0px 0px',
        '@media only screen and (max-width: 1023.5px)': {
            paddingTop: '16px',
        },
    },
    panelRoot: {
        boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
        padding: '0px',
        '& .Mui-focused': {
            background: 'transparent',
        },
        '& .MuiExpansionPanelSummary-root': {
            padding: '0px',
        },
        '& .MuiExpansionPanelSummary-root.Mui-expanded': {
            marginBottom: '0px',
            '@media only screen and (max-width: 600px) ': {
                marginBottom: '0px',
            },
        },

    },
    icons: {
        position: 'absolute',
        right: '60px',
        top: '35px',
        '@media only screen and (max-width: 1024.5px) ': {
            right: '20px',
            top: '20px',
        },
        '@media only screen and (max-width: 768.5px) ': {
            top: '20px',
        },
        '@media only screen and (max-width: 600.5px) ': {
            top: '16px',
            right: '15px',
        },
        '& svg': {
            width: '32px',
            height: '32px',
            '& path': {
                boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
            },
        },
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        fontWeight: 700,
        color: theme.palette.cms?.black || '#2F2F2F',
        minWidth: '450px',
        '@media only screen and (max-width: 600.5px) ': {
            minWidth: '100%',
            display: 'block',
        },

    },
    summaryContent: {
        margin: '20px 60px 0px !important',
        display: 'block',
        '@media only screen and (max-width: 1024.5px) ': {
            padding: '16px 24px 0px',
            margin: '0px !important',
        },
        '@media only screen and (max-width: 600.5px) ': {
            padding: '16px 18px 0px',
        },
    },
    nameContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '30%',
        '@media only screen and (max-width: 600px) ': {
            paddingBottom: '10px',
            width: '90%',
        },
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        '@media only screen and (max-width: 600px) ': {
            justifyContent: 'flex-end',
            width: '157px !important',
        },
        '@media only screen and (max-width: 360.5px) ': {
            display: 'block',
        },
    },
    buttonLabel: {
        fontWeight: 400,
        lineHeight: '1.75rem',
        color: theme.palette.cms?.lightBlue || '#4A90E2',
        textDecoration: 'underline',
        fontSize: '1rem',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '27px',
        margin: '0px',
        cursor: 'pointer',
        '& img': {
            width: '18px',
        },
    },
    editButton: {
        paddingRight: '8px',
        '@media only screen and (max-width: 600.5px) ': {
            paddingRight: '0px',
        },
    },
    detailsRoot: {
        fontSize: '0.875rem',
        overflow: 'auto',
        flexDirection: 'column',
        padding: '0px 60px 0px 60px',
        '@media only screen and (max-width: 1024.5px) ': {
            padding: '0px 24px 0px 24px',
        },
        '@media only screen and (max-width: 600.5px) ': {
            padding: '0px 18px 16px',
        },
        '& .MuiGrid-container': {
            borderTop: `1px solid ${(theme.palette.text?.giftListBorder || '#D5D5D5')}`,
            paddingTop: '12px',
        },
    },
    profileContainer: {
        border: '1px solid rgba(246, 244, 238, 1)',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        marginTop: '0px',
        position: 'relative',
    },
    profile: {
        fontSize: '2rem',
        width: '54px',
        height: '54px',
        border: '1px solid rgba(246, 244, 238, 1)',
        borderRadius: '50%',
        color: 'rgba(56, 113, 84, 1)',
        margin: '2px 0px 0px 2px',
        textAlign: 'center',
        backgroundColor: 'rgba(246, 244, 238, 1)',
        fontFamily: 'Crimson, ivypresto-text, PlayfairDisplayRegular !important',
    },
    cardHeader: {
        display: 'flex',
        gap: '21px',
        paddingBottom: '24px',
        position: 'relative',
        '@media only screen and (max-width: 600.5px) ': {
            paddingBottom: '16px',
        },
    },
    address: {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '20px',
        gap: '40px',
        width: '60%',
        '@media only screen and (max-width: 600.5px) ': {
            maxHeight: '100%',
            width: '100%',
            alignItems: 'flex-end',

        },
        '& >div': {
            '@media only screen and (max-width: 600.5px) ': {
                width: '70%',
            },
        },
        '& > div > div': {
            lineHeight: '1.25rem',
            fontWeight: 400,
        },
        '& .display-none': {
            display: 'none',
        },

    },
    name: {
        textTransform: 'capitalize',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        fontWeight: 700,
        marginRight: '12px',
        '@media only screen and (max-width: 1023.5px) ': {
            fontSize: '1.25rem',
            lineHeight: '1.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',

        },
        '& svg': {
            width: '0.7em',
            color: theme.palette.cms?.lightGreen || '#3F8D5D',
            height: '0.7em',
        },
    },
    expansionIcon: {
        '& svg': {
            width: '34px',
            height: '34px',
        },

    },
    contentWrapper: {
        margin: '0px',
        padding: '10px 0px',
        borderTop: `1px solid ${(theme.palette.text?.giftListBorder || '#D5D5D5')}`,
        '& svg': {
            display: 'none',
        },
        '& button': {
            textDecoration: 'underline',
            color: theme.palette.cms?.lightBlue || '#4A90E2',
            fontSize: '1rem',
        },
        '& .undoButton': {
            padding: '0px',
        },
    },

    productAddedDetails: {
        padding: '0px 60px 12px 60px',
        '@media only screen and (max-width: 1023.5px) ': {
            padding: '0px 24px 12px 24px',
        },
        '@media only screen and (max-width: 600.5px) ': {
            padding: '0px 18px 12px 18px',
        },
    },
    checkCircle: {
        position: 'absolute',
        bottom: '-3px',
        right: '0',
    },
});

const RecipientBoxCollapse = ({
    classes, recipient, onEdit, index,
}) => {
    const [contentActive, setContentActive] = useState(true);
    const dispatch =   useDispatch();
    const handleChangePanel = (recipientIndex) => {
        dispatch(EventDispatcher.setRecipientOpenStateSuccess(recipientIndex));
        setContentActive(!contentActive);
        dispatch(trackEvent({
            eventCategory: 'Gift List V2',
            eventAction: `Recipient Section ${!contentActive ? 'Expanded' : 'Collapsed'}`,
            eventLabel: '',
        }));
    };
    const nameFirstLetter = recipient?.firstname?.split('')?.[0];
    const isTabWidth = useMediaQuery('(max-width: 1023.5px)');
    const { cartDetail } = recipient;
    const isAddedToCart = !isEmpty(cartDetail);

    const addPlusIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16.0001 29.3334C23.3639 29.3334 29.3334 23.3638 29.3334 16C29.3334 8.63622 23.3639 2.66669 16.0001 2.66669C8.63628 2.66669 2.66675 8.63622 2.66675 16C2.66675 23.3638 8.63628 29.3334 16.0001 29.3334Z" stroke="#2F2F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 10.6667V21.3334" stroke="#2F2F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.6667 16H21.3334" stroke="#2F2F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const removeIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16.0001 29.3333C23.3639 29.3333 29.3334 23.3638 29.3334 16C29.3334 8.63616 23.3639 2.66663 16.0001 2.66663C8.63628 2.66663 2.66675 8.63616 2.66675 16C2.66675 23.3638 8.63628 29.3333 16.0001 29.3333Z" stroke="#2F2F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.6667 16H21.3334" stroke="#2F2F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const checkCircle = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M18.622 14.1571C19.0366 13.1562 19.25 12.0834 19.25 11C19.25 8.81196 18.3808 6.71354 16.8336 5.16637C15.2865 3.61919 13.188 2.75 11 2.75C8.81196 2.75 6.71354 3.61919 5.16637 5.16637C3.61919 6.71354 2.75 8.81196 2.75 11C2.75 12.0834 2.96339 13.1562 3.37799 14.1571C3.7926 15.1581 4.40029 16.0675 5.16637 16.8336C5.93245 17.5997 6.84193 18.2074 7.84286 18.622C8.8438 19.0366 9.91659 19.25 11 19.25C12.0834 19.25 13.1562 19.0366 14.1571 18.622C15.1581 18.2074 16.0675 17.5997 16.8336 16.8336C17.5997 16.0675 18.2074 15.1581 18.622 14.1571Z" fill="white" />
            <path d="M8.25 11L10.0833 12.8333L13.75 9.16667M19.25 11C19.25 12.0834 19.0366 13.1562 18.622 14.1571C18.2074 15.1581 17.5997 16.0675 16.8336 16.8336C16.0675 17.5997 15.1581 18.2074 14.1571 18.622C13.1562 19.0366 12.0834 19.25 11 19.25C9.91659 19.25 8.8438 19.0366 7.84286 18.622C6.84193 18.2074 5.93245 17.5997 5.16637 16.8336C4.40029 16.0675 3.7926 15.1581 3.37799 14.1571C2.96339 13.1562 2.75 12.0834 2.75 11C2.75 8.81196 3.61919 6.71354 5.16637 5.16637C6.71354 3.61919 8.81196 2.75 11 2.75C13.188 2.75 15.2865 3.61919 16.8336 5.16637C18.3808 6.71354 19.25 8.81196 19.25 11Z" stroke="#3F8D5D" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    return (
        <div className={classes.container}>
            <Grid container>
                <Grid item xs={12} className={classes.collapseContainer}>
                    <ExpansionPanel classes={{ root: classes.panelRoot }} square expanded={contentActive}  onClick={() => handleChangePanel(index)}>
                        <ExpansionPanelSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent }}>
                            <div className={classes.cardHeader}>
                                {!isTabWidth
                                    && (
                                        <div className={classes.profileContainer}>
                                            <Typography className={classes.profile}>
                                                {nameFirstLetter}
                                            </Typography>
                                            {  isAddedToCart
                                          &&  (
                                              <div className={classes.checkCircle}>
                                                  {checkCircle()}
                                              </div>
                                          )}
                                        </div>
                                    )}
                                <div className={classes.label}>
                                    <div className={classes.nameContainer}>
                                        <Typography className={classes.name}>
                                            {recipient.firstname?.toLowerCase()} {recipient.lastname?.toLowerCase()}
                                        </Typography>
                                    </div>
                                    <div className={classes.address}><Address recipient={recipient} />
                                        {contentActive &&  (
                                            <div className={classes.buttonContainer}>
                                                <Typography
                                                    className={`${classes.button}`}
                                                    onClick={(e) => {
                                                        onEdit(recipient, 'desktop', true);
                                                        e.stopPropagation();
                                                        dispatch(trackEvent({
                                                            eventCategory: 'Gift List V2',
                                                            eventAction: 'Edit Recipient',
                                                            eventLabel: '',
                                                        }));
                                                    }}
                                                    type="button"
                                                >
                                                    <span className={classes.buttonLabel}>Edit/Remove</span>
                                                </Typography>

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <span className={classes.icons} role="presentation">{(contentActive) ? removeIcon() : addPlusIcon()}</span>
                            {(isAddedToCart && !contentActive) &&  <ProductAddedToCart recipient={recipient} classes={classes}  />}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails classes={{ root: isAddedToCart ? `${classes.productAddedDetails} ${classes.detailsRoot}` : classes.detailsRoot }} onClick={(e) => e.stopPropagation()}>
                            {isAddedToCart && recipient?.cartDetail && <GiftListAddedProduct  recipient={recipient} />}
                            {!isAddedToCart &&  <RecipientBoxExpand recipient={recipient} />}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Grid>
            </Grid>
        </div>
    );
};

RecipientBoxCollapse.propTypes = {
    classes: object.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        FirstName: string,
        LastName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                PostalCode: string,
                Country: string,
            }),
        ),
    }),
    onEdit: func,
    index: number.isRequired,
};
RecipientBoxCollapse.defaultProps = {
    recipient: {},
    onEdit: () => {},
};
export default withStyles(styles)(RecipientBoxCollapse);
